// Confirmation text for deleting a Library record (activity or session).
// Deletes are permanent, so the message names the record and says so.
const displayName = (name) => (name || "").trim() || "Untitled";

export function deleteConfirmMessage({ kind, name, activityCount = 0, isOpen = false } = {}) {
  const label = displayName(name);
  if (kind === "session") {
    const n = Number(activityCount) || 0;
    const count = `${n} activit${n === 1 ? "y" : "ies"}`;
    const open = isOpen
      ? " It is open now: your workspace will stay as it is, and saving will create a new session."
      : "";
    return `Delete the session "${label}" and its ${count}? This can't be undone.${open}`;
  }
  return `Delete the activity "${label}" from your Library? This can't be undone.`;
}
